<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
export default {
    name: 'app',
}
</script>

<style lang="less">
@import url("./css/common.css");
@import './common.less';

* {
    padding: 0;
    margin: 0;
}

.primary-btn {
    min-width: 125px;
    height: 55px;
    line-height: 55px;
    text-align: center;
    color: #fff;
    font-size: 19px;
    font-weight: bold;
    border-radius: 8px ;
    background: linear-gradient(to left, @SecondaryColor, @MainColor);
}
</style>
